import {Component, inject, OnInit} from '@angular/core';

import {Router} from "@angular/router";
import {OidcService} from "../../../services/oidc.service";
import {PrivacyNoticeDialogComponent} from "../../../components/dialogs/privacy-notice/privacy-notice.component";
import {MatDialog} from "@angular/material/dialog";
import {AppConfigService} from "../../../services/app-config.service";

@Component({
  selector: 'admin-auth-callback-page',
  standalone: true,
  styleUrls: ['admin-auth-callback.page.scss'],
  templateUrl: 'admin-auth-callback.page.html'
})
export class AdminAuthCallbackPage implements OnInit {

  private oidcService: OidcService = inject(OidcService);
  private router: Router = inject(Router);
  private dialog: MatDialog = inject(MatDialog);
  private appConfigService = inject(AppConfigService);

  ngOnInit(): void {
    void this.configAndHandleAuthResult();
  }

  private async configAndHandleAuthResult(): Promise<void> {
    try {
      const auth_result = await this.oidcService.attemptLogin();
      if (!auth_result) {
        await this.router.navigateByUrl('/dashboard');
        return;
      }

      if (this.appConfigService.privacyPromptsDisabled()) {
        await this.router.navigateByUrl('/auth/login');
        return;
      }

      const dialogRef = this.dialog.open(PrivacyNoticeDialogComponent, {
        disableClose: true,
        width: '500px'
      });

      dialogRef.afterClosed().subscribe(async () => {
        await this.router.navigateByUrl('/auth/login');
      });
    } catch (authException) {
      await this.router.navigateByUrl('/auth/login');
    }
  }
}
